export enum ReminderType {
  ALL = "ALL",
  MEDICATION = "MEDICATION",
  APPOINTMENT = "APPOINTMENT",
  INSURANCE = "INSURANCE",
  VACCINATION = "VACCINATION",
  PET_CARE = "PET_CARE",
}

export enum ReminderSubType {
  DOCTOR_VISIT = "DOCTOR_VISIT",
  HEALTH_CHECKUP = "HEALTH_CHECKUP",
  LAB_TEST = "LAB_TEST",
  THERAPY = "THERAPY",
}

export enum ReminderFrequency {
  ONLY_ONCE = "ONLY_ONCE",
  EVERY_DAY = "EVERY_DAY",
  EVERY_OTHER_DAY = "EVERY_OTHER_DAY",
  SPECIFIC_DAYS = "SPECIFIC_DAYS",
  DAY_FREQUENCY = "DAY_FREQUENCY",
}

export enum DayFrequency {
  ONCE = "ONCE",
  TWICE = "TWICE",
  THRICE = "THRICE",
  FOUR_TIMES = "FOUR_TIMES",
}

export interface BaseReminders {
  id: string;
  type: ReminderType;
  subType?: ReminderSubType;
  sourceId: string;
  reminderFor: string;
  startDate: Date;
  endDate: Date;
  eventDate?: Date;
  frequency?: ReminderFrequency;
  timezone?: string;
}

export interface Reminders extends BaseReminders {
  eventTime?: string;
  selectedDays?: number[];
  frequencyValue?: number;
  dayFrequency?: DayFrequency;
  dayFrequencyValue?: string[];
  reminderAttrs?: Record<string, any>;
  notes?: string;
  tier?: "ROUTINE" | "CRITICAL";
}

// sourceId is normally system-set (e.g. pet-care rollover, vaccination,
// NBA-suggested reminders) — optionally allowed here too so Pillbox's "Add
// Reminder" can link the created reminder back to its originating medicine.
export type CreateReminder = Omit<Reminders, "id" | "sourceId"> & {
  sourceId?: string;
};

export type UpdateReminder = Partial<Reminders>;
